import { render, staticRenderFns } from "./VIPiosPay.vue?vue&type=template&id=9b921c1c&scoped=true&"
import script from "./VIPiosPay.vue?vue&type=script&lang=js&"
export * from "./VIPiosPay.vue?vue&type=script&lang=js&"
import style0 from "./VIPiosPay.vue?vue&type=style&index=0&id=9b921c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b921c1c",
  null
  
)

export default component.exports